import DeviceInfo from 'react-native-device-info';
import {parseVersion} from './parseVersion';

export const validateVersion = (expectedVersion: string) => {
  const appVersion = DeviceInfo.getVersion();
  const appVersionArray = parseVersion(appVersion);
  const expectedVersionArray = parseVersion(expectedVersion);

  if (appVersionArray[0] < expectedVersionArray[0]) {
    return false;
  }
  if (appVersionArray[1] < expectedVersionArray[1]) {
    return false;
  }
  if (appVersionArray[2] < expectedVersionArray[2]) {
    return false;
  }
  return true;
};
